import {Component, Input} from '@angular/core';
import {ControlValueAccessor, UntypedFormControl, NG_VALUE_ACCESSOR} from "@angular/forms";
import {MaintenancePlanUtils} from "@app/shared/util/maintenance-plan.utils";
import { isEmpty } from "lodash";

@Component({
    selector: 'app-activities-form',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: ActivitiesFormComponent,
            multi: true
        }
    ],
    templateUrl: './activities-form.component.html',
    styleUrls: ['./activities-form.component.scss']
})
export class ActivitiesFormComponent implements ControlValueAccessor {
    @Input() activities: any;
    @Input() formControl: UntypedFormControl;
    @Input() items;

    private onChangeCallback: (_: any) => {};
    private onTouchedCallback: (_: any) => {};

    constructor() {
    }


    selectionChanged(data: any) {
        this.items = MaintenancePlanUtils.groupSelectedOperations(data);
        if (this.onChangeCallback) {
            this.onChangeCallback(this.items)
        }
    }

    writeValue(obj: any): void {
        this.items = obj || [];
    }

    registerOnChange(fn: any): void {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouchedCallback = fn;
    }

    isEmpty(activities) {
        return isEmpty(activities);
    }
}
